import { compose } from 'redux';
import { connect } from 'react-redux';
import DivisionListLoader from './DivisionListLoader';
import { getMasterDivisionsList } from '../../actions/index';

const mapStateToProps = ({ divisionsMasterList }) => {
  return {
    masterDivList: divisionsMasterList?.data,
  };
};

const mapDispatchToProps = {
  getMasterDivisionsList,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DivisionListLoader);
